import { useEffect, useRef, useState } from "react";
import { TextInput } from 'flowbite-react';
import { Button } from 'flowbite-react';
import axios from 'axios';
import { exit } from 'process';
import logo from './mixart-logo.svg';
import loader from './loading.svg';

function App() {
  const [mouseData, setMouseData] = useState({ x: 0, y: 0 });
  const canvasRef = useRef(null);
  const [canvasCTX, setCanvasCTX] = useState(null);
  const [color, setColor] = useState("#ac94fa");
  const size = 10;
  const [audio, setAudio] = useState(null);
  const [doodleImg, setDoodleImg] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const [feedback, setFeedback] = useState('');
  const [bardResponse, setBardResponse] = useState('');
  const [filename, setFilename] = useState('');
  const [load, setLoad] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
    setDoodleImg(canvas.toDataURL('image/png'))
    setCanvasCTX(ctx);
  }, [canvasRef]);

  const SetPos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    setMouseData({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoad(true);
    setAudio(null);

    const formData = new FormData();
    const canvas = canvasRef.current;
    canvas.toBlob(blob => {
      // Get the current timestamp
      const timestamp = new Date().getTime();

      // Create a File object from the Blob with timestamp-based filename
      setFilename(`canvas_image_${timestamp}.png`); // You can change the file extension as needed
      const image = new File([blob], `canvas_image_${timestamp}.png`, { type: 'image/png' });
      formData.append('imageFile', image); // Append image data
      formData.append('audioFile', audio); // Append file data

      // Send the multi-part form data to the server using a network request (e.g., Axios, fetch, etc.)
      // Replace 'YOUR_API_ENDPOINT' with the actual URL where you want to send the data
      fetch('https://96a4-76-244-43-219.ngrok-free.app/start', {
        method: 'POST',
        body: formData,
      })
        .then(response => {
          // Check if the response is successful
          if (!response.ok) {
            setLoad(false);
            exit(1);
          }

        fetch('https://96a4-76-244-43-219.ngrok-free.app/response', {
          method: 'POST',
          body: formData,
        }).then(response => {
          // Process the file returned by Flask (for example, create a download link)
          // Get the custom header value
          setBardResponse(response.headers.get('bard-response'));
          console.log('Custom Header - bard-response:', bardResponse);
          return response.blob()
        }).then(data => {
          const blob = new Blob([data], { type: 'audio/mpeg' });
          const audioSrc = URL.createObjectURL(blob);
          setAudioUrl(audioSrc);
          setLoad(false);
        })
        .catch((error) => {
          // Handle errors here
          console.error('Error submitting form data:', error);
          setLoad(false);
        });
          
        })

    });

  };

  const handleFeedback = (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append('feedback', feedback);
    data.append('bard', bardResponse);
    data.append('filename', filename);

    setSubmitted(true);

    fetch('https://96a4-76-244-43-219.ngrok-free.app/feedback', {
      method: 'POST',
      body: data,
    })

  }


  const Draw = (e) => {
    if (e.buttons !== 1) return;
    const ctx = canvasCTX;
    ctx.beginPath();
    ctx.moveTo(mouseData.x, mouseData.y);
    setMouseData({
      x: e.clientX - canvasRef.current.getBoundingClientRect().left,
      y: e.clientY - canvasRef.current.getBoundingClientRect().top,
    });
    ctx.lineTo(e.clientX - canvasRef.current.getBoundingClientRect().left, e.clientY - canvasRef.current.getBoundingClientRect().top);
    ctx.strokeStyle = color;
    ctx.lineWidth = size;
    // Set the line cap to round
    ctx.lineCap = "round";
    ctx.stroke();
  };

  return (
    <div className="flex mt-20 w-screen overflow-y-auto flex-col justify-center items-center bg-gradient-to-r space-y-5 ">
      <div className="flex flex-row bg-white justify-center items-center h-16 w-screen absolute top-0 border">
        <img className="h-full py-3 " src={logo} alt="mixart logo"></img>
      </div>
      <h1 className="text-4xl text-center text-gray-700 font-bold">Make remixes from your <span
        class="font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-indigo-300 to-purple-400"
      >
        doodles
      </span>.</h1>
      <div className="w-1/2">
        <label className="block mb-2 text-sm font-medium text-gray-900" for="file_input">Upload a song</label>
        <input className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none" accept="audio/*" id="file_input" type="file" onChange={(e) => { setAudio(e.target.files[0]) }}></input>
      </div>
      <div class="w-1/2 h-80 rounded-xl bg-gradient-to-r border">
        <canvas
          className="flex h-full rounded-lg w-full items-center justify-center back"
          ref={canvasRef}
          onMouseEnter={(e) => SetPos(e)}
          onMouseMove={(e) => SetPos(e)}
          onMouseDown={(e) => SetPos(e)}
          onMouseMove={(e) => Draw(e)}
        ></canvas>
      </div>

      <div
        className="controlpanel flex flex-row space-x-2"
      >
        <input
          className="h-10 rounded-md"
          type="color"
          value={color}
          onChange={(e) => {
            setColor(e.target.value);
          }}
        />
        <button onClick={() => {
          const ctx = canvasCTX;
          ctx.clearRect(
            0,
            0,
            canvasRef.current.width,
            canvasRef.current.height
          );
        }} class="relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-indigo-300 to-purple-400  group-hover:from-purple-400 group-hover:to-blue-300 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 ">
          <span class="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
            Clear
          </span>
        </button>
        <button onClick={handleSubmit} type="button" class="text-white bg-gradient-to-br transition-all ease-in from-indigo-300 to-purple-400 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2">Submit</button>
        {load && <img className="animate-spin h-auto w-5 algin-middle mr-2 mb-2 ml-2" src={loader} />}
      </div>
      {audioUrl && (
        <audio controls>
          <source src={audioUrl} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      )}
      <div class="flex w-full justify-center flex-row space-x-2">
      {audioUrl && (
        <TextInput
          id="large"
          sizing="lg"
          type="text"
          placeholder="Feedback"
          onChange={(e) => setFeedback(e.target.value)}
          onSubmit={handleFeedback}
          onKeyDown={(e) => { if (e.key === 'Enter') handleFeedback(e) }}
        />
      )}
      {submitted && (
        <p>Submitted, thanks!</p>
      )}
      </div>
      <div>
      </div>
    </div>
  );
}

export default App;
